<template>
  <div class="show-phenotype-component pl-0">

    <div class="data-row pl-0">
      <div class="main-header text-left mb-9 mt-0 pt-4">
        {{$t('recipient.phenotype_header')}}
      </div>
      <div class="header d-flex flex-row">
          <img :src="eye_icon" class="mr-2"/>
          <span class="header_label flex-grow-1 text-left">{{$t('recipient.phenotype.physical_features_label')}}</span>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.eye_color')}}</div>
          <div class="data-value flex-grow-1 text-left text-capitalize">{{ $t('phenotype.eye_color.' + materialType + '.' + phenotype.eyeColor) }}</div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.hair_color')}}</div>
          <div class="data-value flex-grow-1 text-left text-capitalize">{{$t('phenotype.hair_color.' + materialType + '.' + phenotype.hairColor).match(/([\/\w \u0400-\u04FFąęśćżźółń-]+)/)[0] }}<br>

          <span class="sub-entry" v-if="$t('phenotype.hair_color.' + materialType + '.' + phenotype.hairColor).match(/\((.*?)\)/)">{{$t('phenotype.hair_color.' + materialType + '.' + phenotype.hairColor).match(/\((.*?)\)/)[0]}}</span>
          </div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.hair_shape')}}</div>
          <div class="data-value flex-grow-1 text-left text-capitalize">{{ $t('phenotype.hair_structure.' + materialType + '.' + phenotype.hairShape) }}</div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.height')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ phenotype.height }} {{$t('cm')}}</div>
      </div>
      <!-- <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.weight')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ phenotype.weight }} {{$t('kg')}}</div>
      </div> -->
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.body_type')}}</div>
          <div class="data-value flex-grow-1 text-left">
              {{$t('phenotype.silhouette.' + materialType + '.' + phenotype.bodyType).match(/([^\s]+)/)[0] }} <br>

              <span class="sub-entry">{{$t('phenotype.silhouette.' + materialType + '.' + phenotype.bodyType).match(/\((.*?)\)/)[0] }}</span> 
          </div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.skin_color')}}</div>
          <div class="data-value flex-grow-1 text-left">{{$t('phenotype.skin_color.' + materialType + '.' + phenotype.skinColor.key).match(/([\/\w \u0400-\u04FFąęśćżźółń-]+)/)[0] }}<br>

          <span class="sub-entry" v-if="$t('phenotype.skin_color.' + materialType + '.' + phenotype.skinColor.key).match(/\((.*?)\)/)">{{$t('phenotype.skin_color.' + materialType + '.' + phenotype.skinColor.key).match(/\((.*?)\)/)[0]}}</span>
        </div>
      </div>
      <v-divider class="my-4"></v-divider>
      <div class="header d-flex flex-row">
          <img :src="blood_icon" class="mr-2"/>
          <span class="header_label flex-grow-1 text-left">{{$t('recipient.phenotype.blood_label')}}</span>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.blood_type')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ $t('phenotype.blood_type.' + materialType + '.' + phenotype.bloodType) }}</div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.blood_fh_factor')}}</div>
          <div class="data-value flex-grow-1 text-left">{{ $t('phenotype.blood_rh_factor.' + materialType + '.' + phenotype.bloodRhFactor) }}</div>
      </div>
      <v-divider class="my-4"></v-divider>
      <div class="header d-flex flex-row mt-6">
          <img :src="group_icon" class="mr-2"/>
          <span class="header_label flex-grow-1 text-left">{{$t('recipient.phenotype.origin_label')}}</span>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.race')}}</div>
          <div class="data-value flex-grow-1 text-left">{{$t('phenotype.race.' + materialType + '.' + phenotype.race.key).match(/([\/\w \u0400-\u04FFąęśćżźółń-]+)/)[0] }}<br>

          <span class="sub-entry" v-if="$t('phenotype.race.' + materialType + '.' + phenotype.race.key).match(/\((.*?)\)/)">{{$t('phenotype.race.' + materialType + '.' + phenotype.race.key).match(/\((.*?)\)/)[0]}}</span>
        </div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.ethnicity')}}</div>
          <div class="data-value flex-grow-1 text-left">{{getEthnicity}}</div>
      </div>
      <div class="data-wrapper d-flex flex-row">
          <div class="data-label flex-grow-1 text-left">{{$t('recipient.phenotype.secondary_ethnicity')}}</div>
          <div class="data-value flex-grow-1 text-left">{{getSecondaryEthnicities}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: { 
    phenotype: {
      type: Object,
      required: true
    },
    materialType: {
      type: String,
      required: true
    },
    age: Number,
  },
  computed: {
    getEthnicity() {
      const ethnicity = this.phenotype.ethnicity.key;
      return ethnicity ? this.$t(`phenotype.ethnicity.${this.materialType}.${ethnicity}`) : this.$t(`empty_value`);
    },
    getSecondaryEthnicities() {
      let secondaryEthnicities = '';
      const subethnicities = this.phenotype.secondaryEthnicity.map(e => e.key);

      for (let e in subethnicities) {
        secondaryEthnicities += (e > 0 ? ', ' : '') + this.$t(`phenotype.subethnicities.${this.materialType}.${subethnicities[e]}`);
      }
      return secondaryEthnicities ? secondaryEthnicities : this.$t(`empty_value`)
    },
  },
  setup() {
    const eye_icon = computed({
      get: () => { return require('../assets/icons/eye.svg');}
    })
    const blood_icon = computed({
      get: () => { return require('../assets/icons/blood.svg');}
    })
    const group_icon = computed({
      get: () => { return require('../assets/icons/group.svg');}
    })
    return {
        eye_icon,
        blood_icon,
        group_icon,
    }
  }
}
</script>
<style lang="scss" scoped>
  .label {
    @include nsb-font-label;
    font-size: 12px;
    line-height: 18px;
    color: rgb(51,51,51);
  }
  .data {
    @include nsb-font-container-medium;
    font-size: 14px;
    line-height: 21px;
  }

.header {
  @include nsb-font-container-medium;
  font-size: 14px;
  line-height: 21px;
  color: $ds-primary;
}
.data-wrapper {
  @include nsb-font-container;
  font-size: 14px;
  line-height: 21px;
  margin: 8px auto;
  .data-label {
      width: 45%;
      color: $ds-primary-3;
  }
  .data-value {
      width: 55%;
      color: $ds-primary;
  }
}
.sub-entry {
  font-size: 12px;
  color: $ds-primary;
}
.main-header {
  @include nsb-font-main-header;
}
</style>
